import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ToastController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GrupoProvider } from 'src/app/services/grupo/grupo';

@Component({
  selector: 'app-grupo-gerenciar-solicitacao-anotacao',
  templateUrl: './grupo-gerenciar-solicitacao-anotacao.page.html',
  styleUrls: ['./grupo-gerenciar-solicitacao-anotacao.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule
  ],
})
export class GrupoGerenciarSolicitacoesAnotacaoPage implements OnInit {
  validations_form: FormGroup;
  validation_messages = {
    'anotacao': [
      { type: 'required', message: this.translate.instant('Campo Obrigatório') }
    ]
  };
  idGrupo: string = '';
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private translate: TranslateService,
    public grupoProvider: GrupoProvider
  ) {
    this.validations_form = this.formBuilder.group({
      anotacao: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/)
        ]
      ]
    });
    this.idGrupo = this.navParams.get('idGrupo');
  }

  ngOnInit() { }

  onSubmit(form: { anotacao: any; }) {
    this.modalCtrl.dismiss(form);
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
